import { createContext } from "react";

export const PlantContext = createContext();